import React, { useEffect, useMemo, useState } from 'react';
import ChatList from '../components/ChatList';
import ChatWindow from '../components/ChatWindow';
import { useParams } from 'wouter';
import axiosInstance from '@/lib/axiosInstance';
import SocketBridge from '@/components/SocketBridge';
import { ConversationItem } from '@/types/converstion';
import { useSelector } from 'react-redux';
import { useToast } from '@/hooks/use-toast';

export default function MessagesPage() {
  const { user, token } = useSelector((state: any) => state.auth);
  const { toast } = useToast();
  const currentUserId = user?.id || user?._id || ''; // adapt to your payload shape
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const { conversationId } = useParams()

  const [selected, setSelected] = useState<string>(conversationId || "");
  const [conversations, setConversations] = useState<ConversationItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  // Fetch conversations for the left list and for counterpart details
  const fetchConversations = async () => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get(`/api/chat/conversations`);
      setConversations(data.data || []);
    } catch (e) {
      toast({
        title: "Error",
        description: "Failed to fetch conversations",
        variant: "destructive",
      })
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConversations();
  }, []);

  // Selected conversation’s metadata (property + counterpart)
  const selectedConversation = useMemo(
    () => conversations.find(c => c._id === selected) || null,
    [conversations, selected]
  );

  return (
    <>
      <SocketBridge
        token={token}
        currentUserId={currentUserId}
        getActiveConversationId={() => selected || null}
      />
      <div className="h-[80vh] grid grid-cols-1 md:grid-cols-3 gap-4 mt-1">
        <div className="md:col-span-1">
          {/* ChatList remains focused on list and selection.
              It can still auto-refresh internally; we also fetched here to pass counterpart to ChatWindow. */}
          <div className='border mb-1 p-2 bg-gray-100'>
            <h2 className='text-center font-bold'>{user?.userType == "buyer" ? "Seller" : "Buyer"} List</h2>
          </div>
          <ChatList
            token={token}
            selected={selected}
            setSelectedUser={setSelectedUser}
            selectedUser={selectedUser}
            onSelect={(id: string) => setSelected(id)}
          />
        </div>

        <div className="md:col-span-2">
          {selected ? (
            <ChatWindow
              token={token}
              conversationId={selected}
              currentUserId={currentUserId}
              counterpart={selectedConversation?.counterpart || undefined}
            />
          ) : (
            <div className="h-full border rounded flex items-center justify-center text-gray-500">
              Select a conversation
            </div>
          )}
        </div>
      </div>
    </>
  );
}
